import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Row, Col } from "react-bootstrap"
import { useBoolean } from '@fluentui/react-hooks';
import { useGetMessageById } from '../../../../../hooks/services/sBook/useOfMessage';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import MessageBox from '.';
import '../../../../../styles/css/LeftPanel.css'

function SidePanelViewMessage(props) {
    const { t } = useTranslation();

    //Parametros de entrada.
    const inputParam_BookObject = props.bookObject !== null && props.bookObject !== undefined ? props.bookObject : null;
    const inputParam_MessageId = props.messageId !== null && props.messageId !== undefined ? props.messageId : null;
    const inputParam_MessageSectionId = props.messageSectionId !== null && props.messageSectionId !== undefined ? props.messageSectionId : null;
    const inputParam_MessageStatusId = props.messageStatusId !== null && props.messageStatusId !== undefined ? props.messageStatusId : null;
    const inputParam_UserProps = props.userProps !== null && props.userProps !== undefined ? props.userProps : null;
    const inputParam_CurrentUserName = props.currentUserName !== null && props.currentUserName !== undefined ? props.currentUserName : null;
    const inputParam_SetterObjMessageList = props.setterObjMessageList !== null && props.setterObjMessageList !== undefined ? props.setterObjMessageList : null;
    
    const inputParam_FireGetMessage = props.fireGetMessage !== null && props.fireGetMessage !== undefined ? props.fireGetMessage : null;
    const inputParam_SetFireGetMessage = props.setFireGetMessage !== null && props.setFireGetMessage !== undefined ? props.setFireGetMessage : null;
    

    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;

    //Parametros de componente.
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
     
    const [objMessage, setObjMessage] = useState({
        id: null,
        messageNemo: null,//Not null
        messageCode: null,//Not null
        correlative: null,
        title: null,
        body: null,
        topicId: null,
        senderUsername: null,//Not null
        sectionPartySenderId: null,//Not null
        sendDate: null,
        answerNeeded: null,
        answerToMessage: null,
        answerMessageNemo: null,
        answerMessageId: null,
        answerDeadlineDate: null,
        attacheds: false,
        statusId: null,
    });

    //[##SectionPartyMember Get Message Corrección 09-08-2024##]
    useGetMessageById(
        inputParam_MessageId,
        inputParam_UserProps.l_SectionPartyMemberHandler.find(
            x => x.sectionId === inputParam_MessageSectionId
        ) === undefined
            ? (inputParam_UserProps.isAdmin ? 0 : "#NA#")
            : inputParam_UserProps.l_SectionPartyMemberHandler.find(
                x => x.sectionId === inputParam_MessageSectionId
            ).sectionPartyMemberId,
        setObjMessage,
        inputParam_FireGetMessage,
        inputParam_SetFireGetMessage
    )

    //Funciones de componente.
    
    //Eventos de componente.

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onHideDialogAndPanel = () => {
        onDismissPanel();
        hideDialog();
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };

    const onDismissPanel = () => {
        inputParam_SetterIsPanelOpen(false);
    };

    const onRenderFooterContent = () => {
        return <div>
            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
        </div>
    };

    //Render de componente.
    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isOnRightSide={false}
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-boxname-communication') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                customWidth={ undefined }
                className="left-panel"
                type={ PanelType.customNear }
            >
                <Row className="pt-3">
                    <Col xl={12}>
                        {
                            objMessage.id &&
                            <MessageBox
                                bookObject={inputParam_BookObject}
                                messageObjectId={ inputParam_MessageId }
                                messageObjectSectionId={ inputParam_MessageSectionId }
                                messageObjectStatusId={ inputParam_MessageStatusId }
                                userProps={inputParam_UserProps}
                                setterFireUpdateBoxListControl={null} 
                                editMode={false}
                                
                                currentUserName={inputParam_CurrentUserName}
                                setterObjMessageList={inputParam_SetterObjMessageList}
                                setFireGetMessage={inputParam_SetFireGetMessage}
                            />
                        }
                    </Col>
                </Row>
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>
        </div>
    );
}

export default SidePanelViewMessage;